<template>
  <div v-if="isShow" class="add-project">
    <a class="add-project-close" href="javascript:;" title="关闭" @click="close">X</a>
    <el-tabs v-model="activePage" @tab-click="tabChange" type="border-card">
      <el-tab-pane
        :label="component.label"
        :name="''+index"
        v-for="(component, index) in components"
        :key="index"
        style="padding:0 10px"
      >
        <pageOne
          v-if="index === 0"
          ref="pageOne"
          style="flex-grow: 1;"
          @toChooseCity="toChooseCity"
          @createProject="createProject"
          :hasCreated="hasCreated"
          @next="next"
        ></pageOne>
        <component
          :is="component.name"
          v-else
          :ref="component.name"
          :active-carousel="components[activePage]"
          :project="project"
          style="flex-grow: 1;"
          @modifyProject="modifyProject"
          @getProject="getProject"
          @next="next"
        ></component>
      </el-tab-pane>
    </el-tabs>
    <div v-if="activePage > 0" class="prev-btn-box">
      <el-button icon="el-icon-arrow-left" circle @click="prev" type="primary" plain></el-button>
    </div>
    <div v-if="activePage != 0 && activePage < components.length - 1" class="next-btn-box">
      <el-button icon="el-icon-arrow-right" circle @click="next" type="primary" plain></el-button>
    </div>

    <!-- <header class="display-flex-center">
      <h3 class="inline-block mr10" @click="prev">新建项目</h3>
      <div class="inline-block display-flex align-center" @click="next">
        <span
          v-for="(component, index) in components"
          :key="index"
          :class="{ active: activePage >= index, step: true }"
        >
          <span v-if="index !== 0">---</span>
          {{ component.label }}
        </span>
      </div>
    </header>
    <el-carousel
      ref="carousel"
      :initial-index="activePage"
      indicator-position="none"
      arrow="never"
      :autoplay="false"
      :loop="false"
      style="height: calc(100% - 46px)"
    >
      <el-carousel-item v-for="(component, index) in components" :key="index" class="carousel-page">
        <span class="position-step">{{ activePage + 1 }}/{{ components.length }}</span>
        <pageOne
          v-if="index === 0"
          ref="pageOne"
          style="flex-grow: 1;"
          @toChooseCity="toChooseCity"
          @createProject="createProject"
        ></pageOne>
        <component
          :is="component.name"
          v-else
          :ref="component.name"
          :active-carousel="components[activePage]"
          :project="project"
          style="flex-grow: 1;"
          @modifyProject="modifyProject"
          @getProject="getProject"
          @next="next"
        ></component>
      </el-carousel-item>
    </el-carousel>-->

    <!-- dialog-component -->
    <confirmDialog ref="confirmDialog" :project="project" @confirm="confirmDialog"></confirmDialog>
    <ChooseCity ref="ChooseCity"></ChooseCity>
  </div>
</template>

<script>
import {
  pageOne,
  pageTwo,
  pageThree,
  pageFour,
  pageFive,
  pageSix,
  confirmDialog,
  ChooseCity,
} from '../components/AddProject'

export default {
  components: { pageOne, pageTwo, pageThree, pageFour, pageFive, confirmDialog, pageSix, ChooseCity },
  props: {},
  data () {
    return {
      components: [
        { name: 'pageOne', label: '项目新建' },
        { name: 'pageTwo', label: '职位JD' },
        { name: 'pageThree', label: '客户信息' },
        { name: 'pageFour', label: '寻访方向' },
        { name: 'pageFive', label: '亮点优势' },
        { name: 'pageSix', label: '人才画像' },
      ],
      activePage: '0',
      project: {},
      isShow: false,
      hasCreated: false
    }
  },
  watch: {},
  mounted () {
    // this.getProject()
    // this.activePage = 0
  },
  methods: {
    tabChange () {
      if (this.hasCreated) {
        this.modifyProject()
      } else {
        this.$confirm('请先填写创建项目', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showClose: false,
          showCancelButton: false
        }).then(() => {
          this.activePage = "0"
        }).catch(() => {
          this.activePage = "0"
        })

      }
    },
    open () {
      this.isShow = true
      this.hasCreated = false
      this.activePage = '0'
      this.project = {}
      this.$refs.pageOne && this.$refs.pageOne[0] && this.$refs.pageOne[0].init()
    },
    close () {
      if (this.activePage == 0) {
        if (this.hasCreated) this.isShow = false
        else this.$refs.pageOne[0].checkClose(() => (this.isShow = false))
      } else {
        this.$confirm('您的正在完善项目信息，该项目已创建成功，系统将保存您已填写的数据，是否确认退出？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.modifyProject({ ifClose: true })
            this.isShow = false
          })
          .catch(() => {
            this.isShow = false
          })
      }
    },
    prev () {
      if (this.activePage == 0) return
      this.activePage = parseInt(this.activePage) - 1 + ''
      this.modifyProject()
      // this.$refs.carousel.prev()
    },
    next () {
      if (this.activePage == this.components.length - 1) return
      this.activePage = parseInt(this.activePage) + 1 + ""
      this.modifyProject()
      // this.$refs.carousel.next()
    },
    toChooseCity (param = {}) {
      this.$refs.ChooseCity.open(param.default, param.func)
    },
    createProject (project) {
      this.project = project
      this.hasCreated = true
      // this.next()
      this.$refs.confirmDialog.open()
    },
    async getProject () {
      try {
        const project = await app.service('project').fetch(this.project._id)
        this.project = project
      } catch (e) {
        console.log(e.message)
      }
    },
    async modifyProject (args) {
      try {
        if (this.project._id) {
          await window.app.service('project').modify({
            id: this.project._id,
            param: this.project,
          })
          this.project = Object.assign({}, this.project)
          args && args.callback && args.callback()
          args ? (this.isShow = !args.ifClose) : (this.isShow = true)
        }
      } catch (e) {
        this.$message.error(`update project :${e.message}`)
      }
    },
    confirmDialog ({ type, data }) {
      if (type === 'continue') this.next()
      else if (type === 'copyProject') {
        const delFields = [
          '_id',
          '__requestId',
          '__requestSender',
          'files',
          '预计推荐时间',
          '实际推荐时间',
          '项目人才',
          'Y',
          'F',
          ' N',
          '未沟通',
          '已推荐',
          '面试',
          '终面',
          'offer',
          '到岗',
          'auc_score',
        ]
        delFields.forEach(f => {
          delete data[f]
        })
        Object.keys(data).forEach(field => {
          if (!this.project[field]) this.project[field] = data[field]
        })
        window.open(`${window.origin}/#/project20/${this.project._id}`)
      } else if (type === "complete") {
        this.$router.push("/project20/" + this.project._id)
        this.close()
      }
    },
  },
}
</script>
<style>
.add-project .el-carousel__container {
  height: 100%;
}
</style>
<style scoped src="../../statistics/css/addProject.css"></style>
